import { Component } from '@angular/core'

// Language activation and preloading happen in the appConfig app initializer (see app.config.ts).
// This component is only the content-projection wrapper for the app shell.
@Component({
  selector: 'app-transloco-root',
  template: '<ng-content></ng-content>',
  standalone: true,
  imports: [],
})
export class TranslocoRootComponent {}
